<template>
    <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]" :id="'test'+plytyp+'x'+bettyp">
      <div data-template="template0" class="wrap-template template0"> <!-- class 'is_rang' allbet clash -->
        <div class="main-handicap">
          <div class="vrow items-center template-title is_fold">
            <div class="play-name col" @click="showLeg()">
              <span class="ellipsis">{{ getTitleCaption() }}</span>
            </div>
            <div style="width: 37px;" @click="setToTop($event)">
              <span class="set_top" style="display: none;">
                <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
              </span>
            </div>
          </div>
          <template v-if="show">
            <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][bettyp]).length)">
              <template
                v-if="newAllBetEvent.od[plytyp][bettyp][Object.keys(newAllBetEvent.od[plytyp][bettyp])[subMatchKey]]">
                <div class="handicap">
                    <div class="handicap-item m-oe os-1">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ getTeamLabel('hd') }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tacapt }}</span>
                                            <span class="bet_handicap yb-family-odds"></span>
                                        </div>
                                    </div>
                                </div>
                                <oddDbch :event="newAllBetEvent" :team="'oddsha'" :plyType="plytyp" :betType="bettyp" ref="teamha" :mode="'ab'" :match="subMatchKey" />
                            </div>
                        </div>
                    </div>
                    <div class="handicap-item m-oe os-1">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ getTeamLabel('hd') }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tbcapt }}</span>
                                            <span class="bet_handicap yb-family-odds"></span>
                                        </div>
                                    </div>
                                </div>
                                <oddDbch :event="newAllBetEvent" :team="'oddshb'" :plyType="plytyp" :betType="bettyp" ref="teamhb" :mode="'ab'" :match="subMatchKey" />
                            </div>
                        </div>
                    </div>
                    <div class="handicap-item m-oe os-1">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ getTeamLabel('ha') }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tacapt }}</span>
                                            <span class="bet_handicap yb-family-odds"></span>
                                        </div>
                                    </div>
                                </div>
                                <oddDbch :event="newAllBetEvent" :team="'oddsda'" :plyType="plytyp" :betType="bettyp" ref="teamda" :mode="'ab'" :match="subMatchKey" />
                            </div>
                        </div>
                    </div>
                    <div class="handicap-item m-oe os-1">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ getTeamLabel('ha') }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tbcapt }}</span>
                                            <span class="bet_handicap yb-family-odds"></span>
                                        </div>
                                    </div>
                                </div>
                                <oddDbch :event="newAllBetEvent" :team="'oddsdb'" :plyType="plytyp" :betType="bettyp" ref="teamdb" :mode="'ab'" :match="subMatchKey" />
                            </div>
                        </div>
                    </div>
                    <div class="handicap-item m-oe os-1 no_border_bottom">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ getTeamLabel('ad') }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tacapt }}</span>
                                            <span class="bet_handicap yb-family-odds"></span>
                                        </div>
                                    </div>
                                </div>
                                <oddDbch :event="newAllBetEvent" :team="'oddsaa'" :plyType="plytyp" :betType="bettyp" ref="teamaa" :mode="'ab'" :match="subMatchKey" />
                            </div>
                        </div>
                    </div>
                    <div class="handicap-item m-oe os-1 no_border_bottom">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ getTeamLabel('ad') }} {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tbcapt }}</span>
                                            <span class="bet_handicap yb-family-odds"></span>
                                        </div>
                                    </div>
                                </div>
                                <oddDbch :event="newAllBetEvent" :team="'oddsab'" :plyType="plytyp" :betType="bettyp" ref="teamab" :mode="'ab'" :match="subMatchKey" />
                            </div>
                        </div>
                    </div>
                  <div class="" style="padding: 0.5px; width: 100%;border: 1px solid var(--qq--yb-border-color15);" v-if="subMatchKey != (Object.keys(newAllBetEvent.od[plytyp][bettyp]).length -1)"></div>
                </div>
              </template>
            </template> <!-- END submatch -->
          </template>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    mapGetters
  } from 'vuex'
  import OddDBCHComponents from '../../../components/odd-dbch'
  
  import allBetMixin from '../../../mixins/allBet'
  
  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent: null,
      plytyp: null,
      bettyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
      mode:null
    },
    data() {
      return {
        btypes: [allBetMixin.data().dbchftsBetType, allBetMixin.data().rdbchftsBetType],
        show: true,
      }
    },
    computed: {
      ...mapGetters([
        'foldopenAllBet',
        'foldopenFirstEvent'
      ]),
      newAllBetEvent() {
        // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
        return this.allBetEvent
      }
    },
    watch: {
      foldopenAllBet() {
        if(this.mode=='ab'){
          this.show = (this.$store.getters.foldopenAllBet) ? true : false;
        }
      },
      foldopenFirstEvent() {
        if(this.mode!='ab'){
          this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
        }
      }
    },
    methods: {
      getTitleCaption() {
        var a = 'FT'
        var b = ''
        if (this.plytyp == this.firstHtPlyType) {
          a = '1H'
        }else if (this.plytyp == this.SecondHtPlyType) {
          a = '2H'
        }
  
        // if (this.bettype == this.hdpBetType) {
        a =   this.sportAllBetLang['ALL_BET.SUBHEADER_DBCH_FTS'] ;
       // b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_HDP']
        // } else if (this.bettype == this.bttsBetType) {
        //   b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS']
        // }
  
  
        return a
      },
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      setToTop(e) {
        this.$parent.setToTop(e);
      },
      getTeamLabel(team) {
        // var or = this.sportAllBetLang['ALL_BET.LBL_OR']
        if (team == 'ha') {
          return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] 
          // return this.newAllBetEvent.tacapt + or + this.newAllBetEvent.tbcapt
        } else if (team == 'ad') {
          return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW']
          // return this.newAllBetEvent.tbcapt + or + this.sportAllBetLang['ALL_BET.LBL_DRAW']
        } else if (team == 'hd') {
          return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']
          // return this.newAllBetEvent.tacapt + or + this.sportAllBetLang['ALL_BET.LBL_DRAW']
        }
      },
      addToMyMarket(plytyp, onex2BetType) {
        if (this.selectMarket)
          this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp, onex2BetType) {
        if (this.removeMarket)
          this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial)
      },
      // oddsHeader(onex2BetType) {
      //   var retCapt = ''
      //   if (this.isSpecial) {
      //     retCapt += this.specialLeagueCaption(this.allBetEvent, onex2BetType)
      //   }
      //   return retCapt
      // },
    },
    mounted(){
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }else{
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    },
  }
  </script>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-dbchfts.vue